import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@beef/ui-kit';

import { Checkbox } from 'components';

/**
 * Wrap for React Forms, changes bindings to properly support Redux Forms
 */
export default function withRF(WrappedInput) {
  function RFInput({
    input: { name, value, onChange, onFocus, onBlur },
    meta: { touched, error },
    ...inheritedProps
  }) {
    return (
      <WrappedInput
        {...inheritedProps}
        /**
         * to pass a proper value field onBlur/onFocus to React Forms Field,
         * instead of passing synthetic event, we use custom value passed as second argument by TextInput
         */
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        name={name}
        status={touched && error ? 'fail' : null}
        error={error}
        errorMessage={error}
      />
    );
  }

  RFInput.propTypes = {
    /** redux-form props */
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
    }),
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),

    // inheritedProps
  };

  /**
   * Override component name by prepending `RF~`
   * to make it look nice, for example: `RFTextInput`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'RFInput';
    RFInput.displayName = `RF${WrappedComponentName}`;
  }

  return RFInput;
}

function inputWrap(props) {
  return <Input {...props} />;
}

function phoneInputWrap(props) {
  return <Input type="tel" {...props} maskSettings={{ mask: '_', format: '+7 ### ### ####' }} />;
}

export const RFTextInput = withRF(inputWrap);
export const RFPhoneInput = withRF(phoneInputWrap);
export const RFCheckbox = ({ input: { value, onChange }, ...props }) => (
  <Checkbox {...props} handleChange={onChange} checked={!!value} />
);

RFCheckbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func,
  }),

  /** inherited props */
  children: PropTypes.any,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
